import { MAX_LISTED_LINE_NUMBERS } from '../constants/whatsapp';
import type { CsvProblem } from '../types/whatsapp';

function describeLines(lineNumbers: number[]): string {
  if (lineNumbers.length === 0) return '';

  const listed = lineNumbers.slice(0, MAX_LISTED_LINE_NUMBERS).join(', ');
  const hidden = lineNumbers.length - MAX_LISTED_LINE_NUMBERS;

  return hidden > 0 ? `Rows ${listed} and ${hidden} more.` : `Rows ${listed}.`;
}

export default function CsvProblemList({
  problems,
}: {
  problems: CsvProblem[];
}) {
  return (
    <div className="space-y-2" role="alert">
      {problems.map((problem) => (
        <div
          key={problem.message}
          className="rounded-md bg-red-50 px-4 py-2 text-sm text-red-700"
        >
          {problem.message} {describeLines(problem.lineNumbers)}
        </div>
      ))}
    </div>
  );
}
